<template>
    <div class="relative radius-large" v-click-outside="closeWindow">
        <button class="btn wide mr-3" @click="toggleWindow">
            <i class="ico-add large"></i>
            New Agent
        </button>

        <!-- <button class="btn wide mr-3" @click="invite">
            <i class="ico-add large"></i>
            New Agent
        </button> -->

        <div class="floating-menu shaded" v-if="showWindow">
            <h5>Search for agents</h5>

            <div class="form-group" >
                <input
                    class="w-100 fs-small"
                    type="email"
                    v-model.trim="form.email"
                    @input="searchInputChanged"
                    placeholder="e.g. guide@pluralo.com">

                <!-- <div v-if="$v.form.email.$error" class="my-1 messages normal">
                    <span v-if="!$v.form.email.email">Must be a valid email.</span>
                </div> -->
            </div>

            <div class="dark fs-small normal">
                <div v-if="form.email.length > 0">
                    <div v-if="filteredAgents.length > 0" class="agentList">
                        <div class="darker my-3 font-weight-600">Select to Add</div>
                        <div class="row w-100 mx-0 mb-2 justify-content-between mt-1" v-for="agent in filteredAgents">
                            <div class="d-flex w-25" v-if="agent.image && agent.image != ''">
                                <div class="bg-medium h-100 w-100 radius-normal imageCoverCenter" :style="{ 'background': 'url('+agent.image+')' }">
                                </div>
                            </div>
                            <div class="w-50 pointer" @click="openAgentInfo(agent)">
                                <div class="darkest hoverLink">{{agent.brandName}}</div>
                                <div class="fs-smaller">
                                    <span v-if="agent.location">{{agent.location + ', '}}</span>
                                    <span v-if="agent.place && agent.country && agent.country.name"> , </span>
                                    <span v-if="agent.country && agent.country.name">{{agent.country.name}}</span>
                                </div>
                            </div>
                            <div>
                                <button v-if="agent.helperAlreadyAdded" class="btn tertiary opacity-50" disabled>Added</button>
                                <div v-else>
                                    <button class="connectStatusButton btn text-capitalize" :disabled="agent.isConnecting && agent.isConnecting" :class="connectButtonClass(agent)" @click="connectToAgent2(agent)">{{agent.isConnecting && agent.isConnecting == true? 'Connecting': connectButtonLabel(agent)}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="">
                        <form class="shaded" @submit.prevent.stop="invite">
                            <input type="submit" class="btn blue wide full mt-4" value="Create New">
                        </form>
                    </div>
                </div>
                <div v-else>
                    Search for a agent in Pluralo by name or email address, or enter an email address to invite someone new.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { required, email } from 'vuelidate/lib/validators'
    import { peopleMixin } from '@/mixins/people'

    export default {
        mixins:[
            peopleMixin
        ],
        data: function() {
            return {
                showWindow: false,
                searched: false,
                found: false,
                foundAgents: null,
                form: {
                    email: '',
                    brandName: '',
                    place: '',
                },
                filteredAgents: []
            }
        },
        // validations: {
        //     form: {
        //         email: {
        //             required,
        //             email,
        //         },
        //     }
        // },
        created: function() {
            this.resetNewAgentSetup();
            // this.downloadAgents();
            this.downloadCommunityAgents()
        },
        computed: {
            ...mapGetters([
                'account',
                'getAgents',
                'getCommunityAgents',
                'getIsDownloadingCommunityAgents',
                'getIsConnectingToCommunityAgents'
            ]),
            // filteredAgents: function() {
            //     let filterQuery = this.form.email.toLowerCase();
            //
            //     if(this.communityAgents){
            //         let filteredArray = this.communityAgents.filter(function(agent){
            //             return (agent.name && agent.name.toLowerCase().indexOf(filterQuery) !== -1) || agent.brandName && agent.brandName.toLowerCase().indexOf(filterQuery) !== -1 || agent.email && agent.email.toLowerCase().indexOf(filterQuery) !== -1
            //
            //         });
            //
            //         // checks if the user is already added, if sow adds flag helperAlreadyAdded
            //         for (var i = 0; i < filteredArray.length; i++) {
            //             for (var o = 0; o < this.getAgents.length; o++) {
            //                 if(filteredArray[i].id == this.getAgents[o].id){
            //                     // this.$set(row, 'helperAlreadyAdded', true)
            //                     filteredArray[i].helperAlreadyAdded = true
            //                     break;
            //                 }
            //             }
            //         }
            //
            //         return filteredArray;
            //     } else {
            //         return [];
            //     }
            //
            // },
            communityAgents: function () {
                return this.getCommunityAgents
            }

        },
        methods: {
            ...mapActions([
                'resetNewAgentSetup',
                'updateNewAgentSetup',
                'associateAgent',
                'clearClonedAgent',
                'downloadCommunityAgents',
                'connectCommunityAgent',
                'downloadAgents',
                'openUnkownAgent'
            ]),
            searchInputChanged: _.debounce(
                function(userFiltered) {
                    this.filterAgents()
                },
                700
            ),
            filterAgents: function() {
                let filterQuery = this.form.email.toLowerCase();

                if(this.communityAgents){
                    let filteredArray = this.communityAgents.filter(function(agent){
                        return (agent.name && agent.name.toLowerCase().indexOf(filterQuery) !== -1) || agent.brandName && agent.brandName.toLowerCase().indexOf(filterQuery) !== -1 || agent.email && agent.email.toLowerCase().indexOf(filterQuery) !== -1

                    });

                    // checks if the user is already added, if sow adds flag helperAlreadyAdded
                    for (var i = 0; i < filteredArray.length; i++) {
                        for (var o = 0; o < this.getAgents.length; o++) {
                            if(filteredArray[i].id == this.getAgents[o].id){
                                // this.$set(row, 'helperAlreadyAdded', true)
                                filteredArray[i].helperAlreadyAdded = true
                                break;
                            }
                        }
                    }

                    this.filteredAgents = filteredArray;
                } else {
                    this.filteredAgents = [];
                }

            },
            search: function() {
                if (this.form.email) {
                    // For now we'll assume all emails are not found on our database
                    axios.get(axios.defaults.baseURL + 'api/people/getagents', {
                        params: { query: this.form.email }
                    }).then((response) => {
                        if(response.status == 200 && response.data.length > 0){
                            this.foundAgents = response.data
                            this.searched = true;
                            this.found = true;
                        } else {
                            this.searched = true;
                            this.found = false;
                        }
                    });

                }
            },
            invite: function() {
                // Set up our form fields. We'll store them for later usage
                this.clearClonedAgent()

                this.updateNewAgentSetup(this.form);

                // Move on to create form

                this.clearForm();

                this.$router.push({ name: 'pluralo.agent.new' });
            },
            toggleWindow: function() {
                this.showWindow = !this.showWindow;
            },
            closeWindow: function() {
                this.clearForm();
                this.resetNewAgentSetup();
            },
            clearForm: function() {
                this.form.email = '';
                this.form.brandName = '';
                this.form.place = '';
                this.searched = false;
                this.found = false;
                this.showWindow = false;
                // this.$v.form.email.$reset();
            },
            connectButtonLabel: function (agent) {
                if(agent.inviteStatus <= 5){
                    return 'Connect'
                }else{
                    return this.peopleInviteStatus(agent).label.toLowerCase()
                }
            },
            connectButtonClass: function (agent) {
                if(agent.inviteStatus <= 5){
                    return 'pointer'
                }else{
                    return 'notAllowed ' + this.peopleInviteStatus(agent).colorClass
                }
            },
            connectToAgent: function(agent) {
                this.associateAgent({
                    supplierId: this.account.supplierId,
                    agent: agent
                }).then((data) => {
                    this.closeWindow();
                })
            },
            connectToAgent2: function(agent) {
                if(agent.inviteStatus > 5){
                    return false
                }

                this.$set(agent, 'isConnecting', true)
                this.connectCommunityAgent({
                    agent: agent
                }).then((data) => {
                    this.$set(agent, 'isConnecting', false)
                    this.downloadAgents()
                    this.closeWindow();
                }).catch(err => {
                    this.$set(agent, 'isConnecting', false)

                })
            },
            openAgentInfo: function (agent) {
                this.openUnkownAgent({
                    agentId: agent.id
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .floating-menu {
        left: auto;
        right: 16px;
        width: 20rem;
    }

    .agentList{
        max-height: 50vh;
        overflow-y: auto;
    }

    .connectStatusButton{
        min-width: 100px;
    }
</style>



// WEBPACK FOOTER //
// AgentInviteButton.vue?d9d33a1c